<template>
  <div id="glamit-integration">
    <spinner />
    <b-modal id="modalGlamitSettings" ref="modalGlamitSettings" :hide-footer="true" @hidden="settings = {}">
      <div slot="modal-title" v-translate>Glamit Settings</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <b-form @submit.prevent="handleSetIntegration">
        <div class="w-100">
          <div class="form-group col-md-12">
            <label class="control-label" v-translate>Store ID</label>
            <input class="form-control col-md-12" type="text" v-model="settings.storeId" id="settings-id" required>
          </div>
        </div>
        <div class="text-right form-group col-12 form-actions">
          <b-button type="submit" variant="primary" size="lg" v-translate :disabled="!settings.storeId">Submit</b-button>
          <b-button type="reset" variant="outline-primary" size="lg" @click="redirectToIntegrations" v-translate>Cancel</b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Spinner from '@/components/Spinner'
import { PLATFORM_AUTHORIZE, FETCH_PROFILE } from '@/store/actions.type'

export default {
  name: 'GlamitIntegrationPage',
  components: {
    Spinner
  },
  data() {
    return {
      integrationDone: false,
      settings: {}
    }
  },
  props: {
    type: {
      type: String,
      default: 'ongoing'
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  watch: {
    user(val) {
      if (!this.integrationDone) {
        this.showSettings()
      }
    }
  },
  beforeMount() {
    this.$store.dispatch(FETCH_PROFILE)
  },
  methods: {
    showSettings() {
      const canDoIntegration = (this.user && this.user.company_id)
      if (!canDoIntegration) {
        const obj = {
          title: 'ERROR',
          message: this.$gettextInterpolate(this.$gettext('Your user doesn\'t have a company defined which is required to be able to enjoy the benefits of the e-commerce integrations.<br><br>Please write to <a href="mailto:%{helpEmail}">%{helpEmail}</a> to get this solved.'), { helpEmail: this.helpEmail }),
          type: 'error'
        }
        this.$root.$children[0].$refs.simplert.openSimplert(obj)
        this.$router.push({ name: 'search' })
      }
      this.$bvModal.show('modalGlamitSettings')
    },
    redirectToIntegrations() {
      this.$router.push({ name: 'company-integrations' })
    },
    handleSetIntegration() {
      this.$store.dispatch(PLATFORM_AUTHORIZE, { slug: 'glamit', code: this.settings.storeId })
        .then(response => {
          this.integrationDone = true
          this.$store.dispatch(FETCH_PROFILE).then(response => {
            const payload = { profile: this.user }
            this.$store.commit('setProfile', payload)
            this.$router.push({ name: 'company-integrations' })
          })
        }, error => {
          let message
          if (error.status === 422) {
            message = this.$gettext('Authorization code doesn\'t exist or is invalid for the client.<br><br>Please try again now you are identified here.')
          } else {
            message = this.$gettextInterpolate(this.$gettext('There were errors while integrating.<br><br>Please try again or write to <a href="mailto:%{integrationsEmail}">%{integrationsEmail}</a> with the following message: <br><br>'), { integrationsEmail: this.integrationsEmail }) + error.body.message
          }
          const obj = {
            title: 'ERROR',
            message,
            type: 'error'
          }
          this.$root.$children[0].$refs.simplert.openSimplert(obj)
          this.$router.push({ name: 'search' })
        })
    }
  }
}
</script>
